import React from 'react';
import { Panel, PanelHeader, PanelBody } from '../../../util/panel';

const ControlPanel = ({ titlePanel, children, ...props }) => {
    return (
        <Panel>
            <PanelHeader>
                {titlePanel}
            </PanelHeader>
            <PanelBody children={children} />
        </Panel>
    )
}

export default ControlPanel;
